import React, { useState } from 'react';
import { Navbar as NextUINavbar } from "@heroui/navbar";
import useAuth from '@/hooks/useAuth';
import NavbarMobileTop from '@/components/Layouts/Default/Partials/Navbar/components/mobile/NavbarMobileTop';
import NavbarMobileMenu from '@/components/Layouts/Default/Partials/Navbar/components/mobile/NavbarMobileMenu';
import NavbarMobileTools from '@/components/Layouts/Default/Partials/Navbar/components/mobile/NavbarMobileTools';
import { usePlan } from '@/features/subscription/hooks/usePlan';
import { PlanStatusEnum } from '@/features/subscription/enum/planStatus';

const NavbarMobile = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isToolsOpen, setIsToolsOpen] = useState(false);
  const [isProBanner, setIsProBanner] = useState(false);
  const { user, logout } = useAuth();
  const { planDetails } = usePlan();

  React.useEffect(() => {
    user &&
    !(
      planDetails?.status === PlanStatusEnum.ACTIVE ||
      planDetails?.status === PlanStatusEnum.TRIALING
    )
      ? setIsProBanner(true)
      : setIsProBanner(false);
  }, [planDetails, user]);

  return (
    <>
      <NextUINavbar
        classNames={{
          base: 'border-b border-gray-medium2 z-50',
          wrapper: 'px-5 min-h-[62px]  z-50',
        }}
      >
        {!isMenuOpen && (
          <NavbarMobileTop
            user={user}
            isMenuOpen={isMenuOpen}
            setIsMenuOpen={setIsMenuOpen}
            isToolsOpen={isToolsOpen}
            setIsToolsOpen={setIsToolsOpen}
          />
        )}
      </NextUINavbar>
      {isToolsOpen && (
        <NavbarMobileTools
          isProBanner={isProBanner}
          toolMenuopen={isToolsOpen}
        />
      )}
      {isMenuOpen && (
        <NavbarMobileMenu
          user={user}
          logout={logout}
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
        />
      )}
    </>
  );
};

export default NavbarMobile;
